import {
  MASS_POSTING_START,
  MASS_POSTING_END,
  MASS_POSTING_RESULTS,
  RESET_MASS_POSTING,
} from '../../actions/MassPostings/ActionTypes';

const initialState = {
  loading: false,
  massPostingResults: [],
};

const MassPostingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASS_POSTING_START:
      return {
        ...state,
        loading: true,
      };
    case MASS_POSTING_END:
      return {
        ...state,
        loading: false,
      };
    case MASS_POSTING_RESULTS:
      return {
        ...state,
        massPostingResults: action.data,
      };
    case RESET_MASS_POSTING:
      return initialState;
    default:
      return state;
  }
};

export default MassPostingsReducer;
